import { ConfigurationToolbar } from "../../components/configuration-toolbar.component";

type TimerProfileToolbarProps = {
  onViewHistory: () => void;
  onRestore: () => void;
};

export function TimerProfileToolbar({
  onViewHistory,
  onRestore,
}: TimerProfileToolbarProps) {
  return (
    <ConfigurationToolbar
      title="Timer Profile"
      subtitle="Manage schedule timer profiles."
      showViewHistory
      showRestore
      onViewHistory={onViewHistory}
      onRestore={onRestore}
    />
  );
}
